module.exports = __webpack_public_path__ + "img/yyzz.e3256353.png";